/**
  * this create news sub nav effect
**/
import $ from 'jquery';

export	function newsSubnav(){
	
	$('ul.newsSubNavContainer__content li.newsHasSubmenu .dropDown').on("click", function(e){ 
		 e.stopPropagation();
	});

	$('#newsByTopic').click(function(){
		$('#newsByYear').removeClass('active');
		$("#newsByYear .dropDown").removeClass('open');
		if($(this).hasClass('active')){
			$(this).removeClass('active');
      			$("#newsByTopic .dropDown").removeClass('open');
   		}else{
			$(this).addClass('active');
			$("#newsByTopic .dropDown").addClass('open');
		}
		
	});

	$('#newsByYear').click(function(){
                $('#newsByTopic').removeClass('active');
                $("#newsByTopic .dropDown").removeClass('open');
                if($(this).hasClass('active')){
			$(this).removeClass('active');
                        $("#newsByYear .dropDown").removeClass('open');
                }else{
                        $(this).addClass('active');
                        $("#newsByYear .dropDown").addClass('open');
                }
                
        });
	
	$("ul.dropDownYearList li.news-archive-year").on("click", function(e){
    		 	var selItem = $(this);
			if(selItem.hasClass('active')){
				selItem.removeClass('active');
			}else{
        			selItem.siblings().removeClass('active');
        			selItem.addClass('active');
			}
    			e.stopPropagation();
	});	
}
